import script from "./html-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./html-editor.vue?vue&type=script&setup=true&lang=ts"

import "./html-editor.vue?vue&type=style&index=0&id=0eb6b27c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb6b27c"]])

export default __exports__